import React from "react";
import Srcset from "@/components/common/Srcset";
import Dropdown from "@/common/Dropdown";
import CharityDropdown from "../../../CharityComp/CharityDropDown";
import MyImpactContentTile from "@/components/BuilderIO/MyImpactContentTile";
import styles from "../AccountDashboard.module.scss";
import { useSelector } from "react-redux";
import { useIsPreviewing } from "@builder.io/react";

const Impact = (props) => {
  const isUserLoggedIn = useSelector((state) => state.loginUser.userLoggedIn);
  const isPreviewing = useIsPreviewing();
  const isPWA = useSelector((state) => state.pwa.is_PWA);

  let impactData = ["Stand Up to Cancer", "abcg", "hfdh"];
  let disabled = [];
  return (
    <div className={`${styles.account_card}`}>
      <div className={`${styles.account_back}`}>
        <a
          
          onClick={() => {
            props.activeTab("");
          }}
        >
          <Srcset
            requirePath={true}
            svgFile={true}
            className={"back_icon"}
            src={"images/Icons/Arrow/Right/large.svg?imbypass=true"}
            alt="back button"
            height="16"
            width="19.11"
            tabIndex={0}
          />
        </a>
        <Srcset
          onClick={() => {
            props.setAccountSidebarOpen(false);
            props.activeTab("");
          }}
          requirePath={true}
          svgFile={true}
          className={"close_icon_account_tab"}
          src={"images/Icons/Cross/Large.svg"}
          alt="cloe button"
          height="16"
          width="19.11"
        />
      </div>
      <div className={`${styles.card_head}`}>
        <div
          className={`x-large-xs xx-large-sm xx-large-md light ${styles.card_title}`}
        >
          My impact
        </div>
      </div>
      {(isUserLoggedIn || isPreviewing) && (
        <div className={`${styles.card_body}`}>
          {props.impactMessage && (
            <div className={`${styles.my_impact_charity_donation}`}>
              {props.charityLogo}
              <span
                className={`normal-md x-small-sm x-small-xs ${styles.donation_txt}`}
              >
                {props.impactMessage}
              </span>
            </div>
          )}
          <div className={`${styles.impact_msg_sec}`}>
            <p className={`x-small-xs small-sm small-md`}>
            What matters to you, matters to us. That&apos;s why we empower you to support the cause partner(s) you feel most passionate about. Select from the list below, and 20% of the proceeds from your next purchase will benefit them.
            </p>
            <div className="impact-dropdown">
              <CharityDropdown />
            </div>
          </div>
          <div className={`${styles.story_card_sec} ${isPWA ? "addBottomMargin_APPNav" :""}`}>
            <MyImpactContentTile />
          </div>
        </div>
      )}
    </div>
  );
};

export default Impact;
